export default __webpack_public_path__ + "static/879-4be300e8286442ebc55061ff7fb62854.gif";